export const policyStatuses = {
  POLICY_CREATED: 'bg-indigo-100 text-indigo-700',
  POLICY_QUOTED: 'bg-indigo-100 text-indigo-700',
  POLICY_CONFIRMED: 'bg-indigo-100 text-indigo-700',
  POLICY_SIGNED: 'bg-indigo-100 text-indigo-700',
  POLICY_STARTED: 'bg-green-100 text-green-700',
  POLICY_STOPPED: 'bg-red-100 text-red-700',
  POLICY_TERMINATED: 'bg-red-100 text-red-700',
  POLICY_SUSPENDED: 'bg-yellow-100 text-yellow-700',
} as const;
